import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "relative bg-gradient-to-br from-zinc-800/90 via-zinc-900/95 to-zinc-800/90 rounded-2xl overflow-hidden border border-zinc-700/50 shadow-2xl" }
const _hoisted_2 = { class: "absolute inset-0 opacity-5" }
const _hoisted_3 = { class: "relative p-6 pb-4" }
const _hoisted_4 = { class: "flex items-center justify-between mb-6" }
const _hoisted_5 = { class: "flex justify-center mb-6" }
const _hoisted_6 = {
  key: 0,
  class: "relative w-64 h-64 sm:w-40 sm:h-40 rounded-2xl overflow-hidden"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "relative px-6 pb-6 py-4" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "flex justify-between items-start mb-6" }
const _hoisted_11 = { class: "font-bold text-2xl text-white mb-1 tracking-tight" }
const _hoisted_12 = { class: "text-sm text-zinc-400 font-medium" }
const _hoisted_13 = { class: "space-y-4" }
const _hoisted_14 = { class: "flex justify-between items-center" }
const _hoisted_15 = { class: "text-zinc-500 font-medium" }
const _hoisted_16 = { class: "relative" }
const _hoisted_17 = { class: "w-full bg-zinc-800 rounded-full h-4 overflow-hidden shadow-inner border border-zinc-700/50" }
const _hoisted_18 = { class: "text-center" }

import { computed, ref } from 'vue'

interface Award {
  id: string
  title: string
  subtitle: string
  imageUrl?: string
  targetAmount: number
  nextMilestone: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AwardCard',
  props: {
    award: {}
  },
  setup(__props: any) {

const totalCommission = ref(parseFloat(localStorage.getItem('totalCommission') || '0'))

const props = __props

const isHovered = ref(false)

const progressPercentage = computed(() => {
  return Math.min(
    Math.round((totalCommission.value / props.award.targetAmount) * 100),
    100
  )
})

const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "group relative w-full transform transition-all duration-700 hover:scale-[1.02]",
    style: {"perspective":"1000px"},
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isHovered.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = false))
  }, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute -inset-1 bg-gradient-to-r from-teal-500 via-emerald-500 to-teal-500 rounded-2xl opacity-0 group-hover:opacity-25 transition-all duration-700" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-r from-teal-500/20 via-transparent to-emerald-500/20" }, null, -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["absolute inset-0 bg-gradient-to-br from-transparent via-white/10 to-transparent transition-all duration-1000", { 'translate-x-full': isHovered.value }])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex items-center space-x-3 transition-transform duration-300", { 'translate-x-1': isHovered.value }])
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "text-sm font-semibold text-teal-400 tracking-wider" }, "CONQUISTA", -1)
          ]), 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["relative transition-all duration-700", { 
              'transform rotate-y-12 scale-105': isHovered.value 
            }]),
            style: {"transform-style":"preserve-3d"}
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["absolute -inset-6 bg-gradient-to-r from-teal-500/30 to-emerald-500/30 rounded-full blur-2xl opacity-0 transition-opacity duration-700", { 'opacity-100': isHovered.value }])
            }, null, 2),
            (_ctx.award.imageUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.award.imageUrl,
                    alt: _ctx.award.title,
                    class: _normalizeClass(["w-full h-full object-contain transition-transform duration-700", { 'scale-110': isHovered.value }])
                  }, null, 10, _hoisted_7),
                  _createElementVNode("div", {
                    class: _normalizeClass(["absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent z-20 transition-transform duration-1000", { 'translate-x-full': isHovered.value }]),
                    style: {"transform":"translateX(-100%)"}
                  }, null, 2)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["w-32 h-32 sm:w-40 sm:h-40 rounded-2xl bg-gradient-to-br from-zinc-700 to-zinc-800 flex items-center justify-center shadow-2xl border border-zinc-600/50 transition-all duration-500", { 'rotate-12 scale-105': isHovered.value }])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-5xl font-bold text-zinc-300 transition-all duration-500", { 'text-teal-400 scale-110': isHovered.value }])
                  }, "+", 2)
                ], 2))
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-r from-transparent via-teal-500/10 to-transparent" }, null, -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["transition-transform duration-300", { 'translate-x-1': isHovered.value }])
            }, [
              _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.award.title), 1),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.award.subtitle), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", {
                class: _normalizeClass(["text-white font-bold text-lg transition-all duration-300", { 'text-teal-300 scale-105': isHovered.value }])
              }, _toDisplayString(formatCurrency(totalCommission.value)), 3),
              _createElementVNode("span", _hoisted_15, _toDisplayString(formatCurrency(_ctx.award.targetAmount)), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: "h-full rounded-full bg-gradient-to-r from-teal-500 via-emerald-500 to-teal-400 relative overflow-hidden shadow-lg transition-all duration-1000 ease-out",
                  style: _normalizeStyle({ width: `${progressPercentage.value}%` })
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-1500", { 'translate-x-full animate-pulse': isHovered.value }]),
                    style: {"transform":"translateX(-100%)"}
                  }, null, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["absolute inset-0 bg-gradient-to-r from-teal-400/50 to-emerald-400/50 transition-opacity duration-1000", { 'opacity-80': isHovered.value }])
                  }, null, 2)
                ], 4)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-zinc-400 text-sm font-medium transition-all duration-300", { 'text-zinc-300 scale-105': isHovered.value }])
              }, [
                _createTextVNode(_toDisplayString(progressPercentage.value) + "% completo ", 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-block transition-transform duration-300", { 'animate-bounce': isHovered.value }])
                }, null, 2)
              ], 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["h-1 bg-gradient-to-r from-teal-500 via-emerald-500 to-teal-500 transition-all duration-1000", { 
          'h-2 shadow-lg shadow-teal-500/50': isHovered.value,
          'animate-pulse': isHovered.value 
        }])
      }, null, 2)
    ])
  ], 32))
}
}

})